// extracted by mini-css-extract-plugin
export var checkmarkList = "CheckmarkList-module--checkmarkList--bVvl9";